import React from 'react';

/**
 * DemographicSafetyBar
 *
 * Renders whatever safety-critical / account actions the consuming
 * dashboard supplies, so they stay reachable no matter what state
 * DemographicGate is in — including the hard-blocked states. This
 * component has no opinion about what counts as "safety-critical" for
 * a given deployment; that's the caller's call, passed in as props.
 *
 * Kept deliberately dumb: a list of {label, onClick} actions rendered
 * as a slim top bar. No new routing or state ownership introduced here.
 */
export default function DemographicSafetyBar({ actions = [] }) {
  if (!actions.length) return null;

  return (
    <div className="fixed top-0 inset-x-0 z-[60] bg-slate-900 border-b border-slate-800 px-4 py-2 flex items-center justify-end gap-3">
      {actions.map((action) => (
        <button
          key={action.label}
          onClick={action.onClick}
          className={`text-xs font-semibold uppercase tracking-wide px-3 py-1.5 rounded-lg transition ${
            action.variant === 'danger'
              ? 'bg-rose-500/10 text-rose-400 hover:bg-rose-500/20 border border-rose-500/30'
              : 'bg-slate-800 text-slate-300 hover:bg-slate-700'
          }`}
        >
          {action.label}
        </button>
      ))}
    </div>
  );
}